export default type => {

	const ratio = {
		default: 1400 / 288,
		project: 1400 / 490,
		team: 1400 / 288,
		ppcProductImage: 90 / 60,
		ppcServiceImage: 855 / 412,
		ppcPageBanner: 1400 / 286,
		sidebarImage: 246 / 104,
		pageBanner: 1400 / 490,
		news: 1400 / 388,
		product: 1400 / 388,
		ppcImageComponent100: 1170 / 500,
		ppcPageComponentAsset: 1170 / 500,
		ppcImageComponent50: 570 / 500,
		ppcHomeSlider: 1200 / 790,
	};

	return ratio[type] || ratio['default'];
};
